<template>
  <div class="PageVenueList m-hp-100 m-fb-col m-hidden m-fb-cross-center">
    <CommonHeader title="公共场馆预约"></CommonHeader>
    <div class="reservation m-relative" v-if="uni === 'zheda'">
      <div class="m-fb btnWrap">
        <div class="btn m-c-FFFFFF" @click="handlerToOnlineReservation">线上活动预约</div>
        <div class="btn m-c-FFFFFF m-ml-24" @click="handlerToNotPublicVenues">非公共场馆资源预约</div>
      </div>
    </div>
    <CommonBox class="m-item-flex-1 m-hp-100 m-fb m-hidden" v-if="isInitDoneFlag">
      <!-- 筛选条件 -->
      <div class="m-w-274 m-p-24-0">
        <div class="m-p-0-24 m-auto m-hp-100">
          <!-- 校区筛选 -->
          <div class="m-border-bottom m-pt-10 m-pb-24">
            <SelfRoomClassify
              @submit="handlerSubmit"
              resourcesType="2"
              @handlerDefaultData="handlerDefaultData"
            ></SelfRoomClassify>
          </div>
          <!-- 资源类型 -->
          <div class="m-pt-24 m-pl-16 m-border-bottom">
            <VenuesTypeClassify
              @handlerCheck="handlerCheckbox"
              :spaceTypeIdBaseConfigIdDto="spaceTypeIdBaseConfigIdDto"
            />
          </div>
          <!-- 可容纳人数 -->
          <div class="m-p-24-0 m-pl-16">
            <div class="m-fb-between-center m-mb-16">
              <span class="m-font-14 m-bold">可容纳人数</span>
              <span
                class="m-font-12 m-c-theme m-pointer"
                @click="handlerCleanPerson"
                v-if="postData.peopleCapacity || postData.peopleCapacity === 0"
                >清除选项</span
              >
            </div>
            <MRadiobox
              class="checkbox"
              :class="{ 'm-mb-8': index !== peopleNumList.length - 1 }"
              v-model="postData.peopleCapacity"
              v-for="(it, index) in peopleNumList"
              :key="index"
              :label="it.label"
              :checkVal="it.value"
            ></MRadiobox>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="m-item-flex-1 m-pt-24 m-hidden m-fb-col">
        <div class="m-fb-between-center m-pr-24">
          <div>
            <MDateTimePickerNew
              v-model="postData.openDate"
              type="date"
              valueFormat="YYYY-MM-DD"
              class="m-w-200"
              :beforeDayEnable="false"
            ></MDateTimePickerNew>
            <m-drop-down
              class="m-ml-12 m-w-120"
              :list="list"
              placeholder="全部资源"
              labelKey="name"
              valueKey="value"
              :clear="true"
              @change="handlerChange"
            ></m-drop-down>
          </div>
          <MSearchBox
            v-model="postData.resourceName"
            placeholder="请搜索楼宇/房间名称"
            class="m-w-240"
            maxlength="30"
          ></MSearchBox>
        </div>
        <template v-if="spaceResourceList.length">
          <m-scroll class="m-item-flex-1" :options="{ width: 4 }" ref="myScroll">
            <div class="m-p-24-0 m-pr-24" v-if="postData.openDate">
              <VenuesBox
                v-for="(it, i) in spaceResourceList"
                :key="it.spaceResourceId"
                :spaceData="it"
                :blackFlag="blackFlag"
                :blackInfo="blackInfo"
                :class="{ 'm-mb-24': i !== spaceResourceList.length - 1 }"
                :time="postData.openDate"
                @handlerToDetails="handlerToDetails(it)"
              />
            </div>
          </m-scroll>
          <div class="m-p-15-0 m-border-top m-fb-end-center m-pr-24">
            <MPagination
              :current-page="currentPage"
              :total="total"
              :page-size="pageSize"
              :pageSizeList="pageSizeList"
              @change-page="handlerToChangePage"
            ></MPagination>
          </div>
        </template>
        <template v-else>
          <CommonNoData tips="未搜索到相关空间" type="search"></CommonNoData>
        </template>
      </div>
    </CommonBox>
    <!-- 协议弹窗 -->
    <OrderAgreementModal :visible.sync="showOrderAgreement" @handlerAgree="handlerAgree" />
    <MDrawer :visible.sync="notPublicVenuesSettingVisible" title="非公共场馆资源预约" :hasMask="true" :width="528">
      <div class="m-fb-col m-hidden m-hp-100">
        <MTips class="m-m-0-24" type="primary">一次最多只能申请五个有效场地</MTips>
        <m-form
          class="notPublicVenuesContent m-m-0-24 m-mt-24 m-item-flex-1"
          ref="form"
          :model="notPublicVenuesPostData"
          label-width="auto"
        >
          <MLabel label="所在校区" required prop="campusId" :labelWidth="88">
            <MDropDown
              v-model="notPublicVenuesPostData.campusId"
              :list="campusList"
              width="252"
              labelKey="campusName"
              valueKey="campusId"
              placeholder="请选择"
              :error="!!notPublicVenuesPostData.error"
            ></MDropDown>
            <MErrorMessage v-show="notPublicVenuesPostData.error">{{ notPublicVenuesPostData.error }}</MErrorMessage>
          </MLabel>
          <MLabel prop="dateTimeDtoList" type="array" :validateEnable="false">
            <div
              class="activeList m-mb-24"
              v-for="(item, index) in notPublicVenuesPostData.dateTimeDtoList"
              :key="index"
            >
              <MLabel label="具体场地" required prop="positionName" :index="index" :labelWidth="88">
                <div class="m-fb-start-center">
                  <MInput
                    v-model="item.positionName"
                    placeholder="请输入"
                    width="252"
                    maxlength="200"
                    :error="!!item.errorPosition"
                  ></MInput>
                  <MButton
                    class="m-ml-16"
                    v-show="notPublicVenuesPostData.dateTimeDtoList.length > 1"
                    @click="handlerDeleteActivity(index)"
                    >删除</MButton
                  >
                </div>
                <MErrorMessage v-show="!!item.errorPosition" :error="item.errorPosition">{{
                  item.errorPosition
                }}</MErrorMessage>
              </MLabel>
              <MLabel label="预约时间" required :labelWidth="88">
                <div class="m-fb-start-stretch">
                  <MDateTimePickerNew
                    style="width: 140px"
                    v-model="item.date"
                    valueFormat="YYYY-MM-DD"
                    placeholder="请选择"
                    :disabledDate="methodDisabledDate"
                  ></MDateTimePickerNew>
                  <MTimePicker
                    class="m-ml-12"
                    v-model="item.beginTime"
                    valueFormat="hh:mm"
                    step="00:05"
                    width="100"
                    :timeRange="methodTimeRange({ end: item.endTime })"
                    :error="!!item.errorTime"
                  ></MTimePicker>
                  <div class="m-m-0-12 m-fb-start-center">-</div>
                  <MTimePicker
                    class="form-time"
                    v-model="item.endTime"
                    valueFormat="hh:mm"
                    step="00:05"
                    width="100"
                    :timeRange="methodTimeRange({ start: item.beginTime })"
                    :error="!!item.errorTime"
                  ></MTimePicker>
                </div>
                <MErrorMessage v-show="!!item.errorTime">{{ item.errorTime }}</MErrorMessage>
              </MLabel>
            </div>
          </MLabel>
          <div class="m-fb-center-start m-mb-24" v-show="notPublicVenuesPostData.dateTimeDtoList.length < 5">
            <MButton @click="handlerAddReservation"><i class="m-icon m-icon-add"></i> 添加预约场地</MButton>
          </div>
        </m-form>
        <div class="footer m-p-18-0 m-fb-center-center">
          <MButton type="primary" :simple="true" size="middle" @click="handlerCancel">取消</MButton>
          <MButton class="m-ml-24" type="primary" size="middle" @click="handlerConfirm">提交</MButton>
        </div>
      </div>
    </MDrawer>
  </div>
</template>
<script>
import { web, time } from '@/mixin'
import { SelfRoomClassify } from '@/components/studyRoom'
import { VenuesTypeClassify, VenuesBox } from '@/components/venue'
import { PEOPLE_NUMBER } from '@/utils/constUtils'
import { timeFormatNew, getItem, setItem, removeItem } from '@/utils/comUtils'
import OrderAgreementModal from '@/components/venue/OrderAgreementModal.vue'
import { uni } from 'CONFIG'

export default {
  mixins: [web, time],
  components: {
    SelfRoomClassify,
    VenuesTypeClassify,
    VenuesBox,
    OrderAgreementModal
  },
  data() {
    return {
      uni,
      list: [
        {
          name: '不限用',
          value: 0
        },
        {
          name: '限用',
          value: 1
        }
      ],
      peopleNumList: PEOPLE_NUMBER, //可容纳人数
      listFunc: this.fetchResourceForUserlist,
      spaceResourceList: [], //资源列表
      roomType: 1,
      notPublicVenuesSettingVisible: false, // 非公共场馆资源预约抽屉是否显示
      showOrderAgreement: false, // 是否显示协议弹框
      blackFlag: getItem('blackFlag') || false, // 是否被拉黑
      blackInfo: {}, //拉黑详情
      campusList: [], // 校区列表
      limit: '', // 是否限用
      postData: {
        buildingIdList: null,
        campusId: '',
        openDate: timeFormatNew(new Date(), 'YYYY-MM-DD'),
        peopleCapacity: '',
        resourceName: '',
        spaceTypeId: '', //选中的资源类型
        baseConfigIdList: [] //选中的配置
      },
      canSubmit: true, // 非公共场馆资源预约是否可以提交
      // 非公共场馆资源预约表单
      notPublicVenuesPostData: {
        campusId: '', // 校区
        reserveType: 7, // 7-非公共场馆资源
        dateTimeDtoList: [
          {
            positionName: '',
            date: timeFormatNew(new Date(), 'YYYY-MM-DD'),
            beginDate: '',
            endDate: '',
            beginTime: '00:00',
            endTime: '23:55'
          }
        ]
      },
      rules: {
        campusId: [
          {
            required: true,
            message: '所在校区不能为空'
          }
        ],
        dateTimeDtoList: {
          type: 'array',
          defaultField: {
            type: 'object',
            fields: {
              positionName: {
                required: true,
                message: '具体场地不能为空'
              }
            }
          }
        }
      }
    }
  },
  watch: {
    postData: {
      handler() {
        this.currentPage = 1
        this.spaceResourceList = []
        this.fetchResourceForUserlist()
      },
      deep: true
    }
  },
  computed: {
    spaceTypeIdBaseConfigIdDto() {
      return { spaceTypeId: this.postData.spaceTypeId, baseConfigIdList: this.postData.baseConfigIdList }
    }
  },
  mounted() {
    // 存在 读缓存
    if (getItem('searchFlag')) {
      this.postData = JSON.parse(getItem('postData'))
      removeItem('searchFlag')
    } else {
      removeItem('postData')
    }
  },
  methods: {
    // 初始查询数据
    init() {
      this.fetchCampusAllListForSelfStudy()
      this.fetchBreachRuleBlackIsIn()
    },
    /**
     * @description: 线上活动预约
     * @return {*}
     */
    handlerToOnlineReservation() {
      if (this.blackFlag) {
        this.methodShowTips()
      } else {
        window.open('https://one.zju.edu.cn/infoplus/form/FW_XSLTJZSQ_New/start?theme=zju_new')
      }
    },
    /**
     * @description: 非公共场馆资源预约
     * @return {*}
     */
    handlerToNotPublicVenues() {
      if (this.blackFlag) {
        this.methodShowTips()
      } else {
        this.showOrderAgreement = true
      }
    },
    /**
     * @Description: 同意协议
     * @return {*}
     */
    handlerAgree() {
      this.showOrderAgreement = false
      this.notPublicVenuesSettingVisible = true
      this.notPublicVenuesPostData = {
        campusId: '', // 校区
        reserveType: 7, // 7-非公共场馆资源
        dateTimeDtoList: [
          {
            positionName: '',
            date: timeFormatNew(new Date(), 'YYYY-MM-DD'),
            beginDate: '',
            endDate: '',
            beginTime: '00:00',
            endTime: '23:55'
          }
        ]
      }
    },
    /**
     * @description: 添加预约场地
     * @return {*}
     */
    handlerAddReservation() {
      this.notPublicVenuesPostData.dateTimeDtoList.push({
        positionName: '',
        date: timeFormatNew(new Date(), 'YYYY-MM-DD'),
        beginDate: '',
        endDate: '',
        beginTime: '00:00',
        endTime: '23:55'
      })
    },
    handlerChange(val) {
      this.limit = val
      this.currentPage = 1
      this.spaceResourceList = []
      this.fetchResourceForUserlist()
    },
    /**
     * @description: 删除活动
     * @param {*} i-下标
     * @return {*}
     */
    handlerDeleteActivity(i) {
      this.notPublicVenuesPostData.dateTimeDtoList.splice(i, 1)
    },
    /**
     * @description: 取消
     * @return {*}
     */
    handlerCancel() {
      this.$refs.form.clearValidate()
      this.notPublicVenuesSettingVisible = false
    },
    /**
     * @description: 提交
     * @return {*}
     */
    handlerConfirm() {
      this.canSubmit = true
      this.notPublicVenuesPostData.error = ''
      if (!this.notPublicVenuesPostData.campusId) {
        this.notPublicVenuesPostData.error = '请选择校区'
        this.canSubmit = false
      }
      this.notPublicVenuesPostData.dateTimeDtoList.forEach((item, index) => {
        this.$set(this.notPublicVenuesPostData.dateTimeDtoList[index], 'errorPosition', '')
        this.$set(this.notPublicVenuesPostData.dateTimeDtoList[index], 'errorTime', '')
        // 具体场地校验
        if (!item.positionName) {
          this.$set(this.notPublicVenuesPostData.dateTimeDtoList[index], 'errorPosition', '请输入具体场地')
          this.canSubmit = false
        }
        if (new Date(`${item.date} ${item.beginTime}`).getTime() - new Date().getTime() <= 0) {
          this.$set(this.notPublicVenuesPostData.dateTimeDtoList[index], 'errorTime', '预约时间须大于当前时间')
          this.canSubmit = false
        }
        // 时间校验
        item.beginDate = timeFormatNew(item.date, 'YYYY-MM-DD')
        item.endDate = timeFormatNew(item.date, 'YYYY-MM-DD')
        // 间隔小于15分钟报错
        if (
          new Date(`${item.endDate} ${item.endTime}`) - new Date(`${item.beginDate} ${item.beginTime}`) <
          15 * 60 * 1000
        ) {
          this.$set(this.notPublicVenuesPostData.dateTimeDtoList[index], 'errorTime', '间隔时间至少15分钟')
          this.canSubmit = false
        }
      })
      this.notPublicVenuesPostData.dateTimeDtoList.forEach(item => {
        item.beginDate = timeFormatNew(item.date, 'YYYY-MM-DD')
        item.endDate = timeFormatNew(item.date, 'YYYY-MM-DD')
      })
      if (!this.canSubmit) return
      this.fetchReserveZjuAdd().then(res => {
        this.notPublicVenuesSettingVisible = false
        window.open(res)
      })
    },
    // 获取默认的校区
    handlerDefaultData(val) {
      this.postData.campusId = val.campusId
    },
    // 楼宇校区选中
    handlerSubmit(val) {
      this.postData.campusId = val.campus
      this.postData.buildingIdList = val.buildIds
    },
    // 清楚人数选项
    handlerCleanPerson() {
      this.postData.peopleCapacity = ''
    },
    //资源类型确定
    handlerCheckbox(val) {
      this.postData.spaceTypeId = val.spaceTypeId
      this.postData.baseConfigIdList = val.baseConfigIdList
    },
    // 查看详情
    handlerToDetails(item) {
      setItem('postData', JSON.stringify(this.postData))
      this.$router.push({
        path: '/venue/list/detail',
        query: { spaceResourceId: item.spaceResourceId, spaceArchivesId: item.spaceArchivesId }
      })
    },
    //全部校区
    async fetchCampusAllListForSelfStudy() {
      let _res = await this.$httpPost('apiCampusAllList')
      this.campusList = (_res || []).slice(0, 7)
    },
    // 空间列表
    async fetchResourceForUserlist() {
      try {
        let _postData = JSON.parse(JSON.stringify(this.postData))
        _postData.paginator = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        _postData.limit = this.limit
        let _res = (await this.$httpPost('apiResourceForUser', _postData)) || {}
        this.spaceResourceList = _res.list || []
        this.$previewRefresh()
        this.total = (_res.paginator || {}).total || 0
      } catch (error) {
        console.log(error)
      } finally {
        this.$nextTick(() => {
          this.$refs.myScroll && this.$refs.myScroll.scrollTop()
        })
      }
    },
    // 非公共场馆资源预约保存
    async fetchReserveZjuAdd() {
      return this.$httpPost('reserveZjuAdd', this.notPublicVenuesPostData)
    },
    /**
     * @description: 当前人员是否拉黑
     * @return {*}
     */
    async fetchBreachRuleBlackIsIn() {
      const _res = await this.$httpGet('breachRuleBlackIsIn')
      this.blackInfo = _res
      if (_res.blackFlag) {
        if (!getItem('blackFlag')) {
          setItem('blackFlag', true)
          this.blackFlag = true
          this.methodShowTips()
        }
      } else {
        removeItem('blackFlag')
        this.blackFlag = false
      }
    },
    methodDisabledDate(target) {
      var _date = new Date()

      _date.setDate(_date.getDate() - 1)

      return target.getTime() < _date.getTime()
    },
    methodShowTips() {
      this.$mconfirm.error({
        isHtml: true,
        message: `您当前已被限制使用，无法预约。<br />禁用时间：${this.blackInfo.startTime} ~ ${this.blackInfo.endTime}`,
        buttons: [{ name: '我知道了', type: 'primary' }]
      })
    }
  }
}
</script>
<style scoped lang="scss">
.PageVenueList {
  .reservation {
    width: 1152px;
  }
  .btnWrap {
    position: absolute;
    top: -46px;
    right: 0px;
    .btn {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .checkbox {
    display: block;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .notPublicVenuesContent {
    overflow: scroll;
    .activeList {
      border-bottom: 1px dashed #ededed;
    }
  }
  .footer {
    box-shadow: 0px -2px 4px 0px rgba(51, 51, 51, 0.08);
  }
}
</style>
